import React from 'react';
import {Link} from "react-router-dom";
import {Helper} from "./Helper";
import {DownloadReportModal} from "react-spaceship-web";

let empty_color = '#000';
let label_color = '#767676';
export default class PaymentByCheques extends React.Component {
	constructor() {
		super();
		let _state;
		window.Route.on({
			'/v2/payment-by-cheques': () => {
				_state = {
					mode: 'list',
					payment_by_cheque: [],
				};
			}
		}).match();
		_state.is_loading = true;
		this.state = _state;
	}

	componentDidUpdate(prevProps) {
		if (this.props.location.pathname !== prevProps.location.pathname) {
			window.Route.on({
				'/v2/payment-by-cheques': () => {
					this.setState({
						mode: 'list',
						is_loading: true,
					}, () => {
						this.fetch();
					})
				},
			}).match();
		} else if (this.props.location.search !== prevProps.location.search) {
			this.setState({
				is_loading: true,
			}, () => {
				this.fetch();
			})
		}
	}

	componentDidMount() {
		if (this.state.mode === 'list') {
			this.fetch();
		}
	}

	fetch() {
		let data = window.Global.getAllQueryStrings();
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/payment/payment_by_cheque',
			data: data,
			done: (response) => {
				let payment_by_cheque = [...response.payment_by_cheque];
				payment_by_cheque.forEach((_payment_by_cheque, _payment_by_cheque_i) => {
					payment_by_cheque[_payment_by_cheque_i].mode = 'view';
				});
				this.setState({
					is_loading: false,
					payment_by_cheque: payment_by_cheque
				}, () => {
					let $search = this.$parent.find('#Search_root');
					if (response.relationship) {
						$search.find('input[name="relationship_id"]').explorer('set value', response.relationship);
					}
					if (response.cheque_bank) {
						$search.find('input[name="cheque_bank_id"]').explorer('set value', response.cheque_bank);
					}
					if (response.status_updated_user) {
						$search.find('input[name="status_updated_user_id"]').explorer('set value', response.status_updated_user);
					}
					this.$parent.find('.Table_root').tablePagination({
						disableContent: true,
						data: response.payment_by_cheque,
						count: response.count,
						onClickPagination: (p) => {
							let qs = window.Global.getAllQueryStrings();
							qs.page = p;
							this.props.history.push(window.Global.getQueryStringLinkFromObject(qs));
						}
					});
				});
				// window.Route.setLink();
			},
			fail: () => {

			}
		});
	}

	setMode(mode, payment_by_cheque_index, payment_by_cheque) {
		let payment_by_cheques = [...this.state.payment_by_cheque];
		if (payment_by_cheque) {
			payment_by_cheques[payment_by_cheque_index] = payment_by_cheque;
		}
		payment_by_cheques[payment_by_cheque_index].mode = mode;
		this.setState({
			payment_by_cheque: payment_by_cheques,
		})
	}


	render() {
		return (
			<div key={'ddd' + window.Global.getRandomInt(1, 99999999)}
			     ref={(ref) => {
				     if (!ref) return;
				     this.$parent = window.$(ref);

				     let $search = this.$parent.find('#Search_root');

				     $search.find('.pointing.dropdown').dropdown({
					     onChange: function (value) {
						     let data = $search.find('form').serializeObject();
						     if (value === 'excel') {
							     data.is_download_excel = true;
							     window.Global.reactToDom(
								     window.$('body'),
								     <DownloadReportModal url={process.env.REACT_APP_DOMAIN + '/api/payment/payment_by_cheque'}
								                          data={data}/>
							     );
						     }
					     }
				     });
			     }}
			     className="main ui container">
				<div style={{marginBottom: '1rem'}}>
					<div className="flex row wrap middle-xs">
						<div className="ui huge breadcrumb">
							<Link className="section active"
							      to="/v2/payment-by-cheques">
								ตรวจสอบเช็ครับ-เช็คจ่าย
							</Link>
						</div>
					</div>
					<div id="Search_root" className="box" style={{display: 'none', marginTop: '1rem'}}
					     ref={(ref) => {
						     let $search = window.$(ref);
						     window.Search.init({
							     $node: $search,
							     onSubmit: (data) => {
								     this.props.history.push(window.Global.getQueryStringLinkFromObject(data));
								     return false;
							     }
						     });
						     $search.find('input[name="relationship_id"]').explorer({
							     url: process.env.REACT_APP_DOMAIN + '/api/relationship',
							     additionalData: () => {
								     return {
									     limit: 10
								     }
							     },
							     key: 'relationship',
							     template: {
								     list: '<a class="item">\n\t<div class="flex row wrap between-xs">\n\t\t<b>{{name}}</b>\n\t</div>\n</a>',
								     selected: {
									     display_template: '{{name}}',
									     value: 'id',
									     placeholder: 'คู่ค้า'
								     }
							     }
						     });
						     $search.find('input[name="cheque_bank_id"]').explorer({
							     url: process.env.REACT_APP_DOMAIN + '/api/bank',
							     additionalData: () => {
								     return {
									     limit: 10
								     }
							     },
							     key: 'bank',
							     template: {
								     list: '<a class="item">\n\t<div class="flex row wrap between-xs">\n\t\t<b>{{name}}</b>\n\t</div>\n</a>',
								     selected: {
									     display_template: '{{name}}',
									     value: 'id',
									     placeholder: 'ธนาคารที่ขึ้นเงิน/หักเงิน'
								     }
							     }
						     });
						     $search.find('input[name="status_updated_user_id"]').explorer({
							     url: process.env.REACT_APP_DOMAIN + '/api/user',
							     additionalData: () => {
								     return {
									     limit: 10
								     }
							     },
							     key: 'user',
							     template: {
								     list: '<a class="item">\n\t<div class="flex row wrap between-xs">\n\t\t<b>{{name}}</b>\n\t</div>\n</a>',
								     selected: {
									     display_template: '{{name}}',
									     value: 'id',
									     placeholder: 'ผู้เปลี่ยนสถานะ'
								     }
							     }
						     });
					     }}>
						<form className="ui form">
							<div className="flex row wrap padded five column computer">
								<div className="column field">
									<div className="field">
										<label>เช็คเลขที่</label>
										<input type="text" name="cheque_no" placeholder={"เช็คเลขที่"}/>
									</div>
								</div>
								<div className="column field">
									<div className="field">
										<label>สาขาเลขที่</label>
										<input type="text" name="cheque_branch" placeholder={"สาขาเลขที่"}/>
									</div>
								</div>
								<div className="column field">
									<div className="field">
										<label>คู่ค้า</label>
										<input type="text" name="relationship_id"/>
									</div>
								</div>
								<div className="column field">
									<div className="field">
										<label>ช่วงวันที่รับ/จ่ายเช็ค</label>
										<div data-form_calendar="date"
										     data-input_name="start_paid_on"
										     data-placeholder="ช่วงวันที่"
										     data-end_calendar="end_paid_on"
										     data-locale="th"
										     data-initialdate=""
										/>
									</div>
								</div>
								<div className="column field">
									<div className="field">
										<label>ถึงวันที่</label>
										<div data-form_calendar="date"
										     data-input_name="end_paid_on"
										     data-placeholder="ถึงวันที่"
										     data-start_calendar="start_paid_on"
										     data-locale="th"
										     data-initialdate=""
										/>
									</div>
								</div>
								<div className="column field">
									<div className="field">
										<label>ช่วงวันที่เช็ค</label>
										<div data-form_calendar="date"
										     data-input_name="start_cheque_doc_date"
										     data-placeholder="ช่วงวันที่"
										     data-end_calendar="end_cheque_doc_date"
										     data-locale="th"
										     data-initialdate=""
										/>
									</div>
								</div>
								<div className="column field">
									<div className="field">
										<label>ถึงวันที่</label>
										<div data-form_calendar="date"
										     data-input_name="end_cheque_doc_date"
										     data-placeholder="ถึงวันที่"
										     data-start_calendar="start_cheque_doc_date"
										     data-locale="th"
										     data-initialdate=""
										/>
									</div>
								</div>
								<div className="column field">
									<div className="field">
										<label>ธนาคารที่ขึ้นเงิน/หักเงิน</label>
										<input type="text" name="cheque_bank_id"/>
									</div>
								</div>
								<div className="column field">
									<div className="field">
										<label>ช่วงวันที่ได้รับเงิน/หักเงิน</label>
										<div data-form_calendar="date"
										     data-input_name="start_cheque_pass_date"
										     data-placeholder="ช่วงวันที่"
										     data-end_calendar="end_cheque_pass_date"
										     data-locale="th"
										     data-initialdate=""
										/>
									</div>
								</div>
								<div className="column field">
									<div className="field">
										<label>ถึงวันที่</label>
										<div data-form_calendar="date"
										     data-input_name="end_cheque_pass_date"
										     data-placeholder="ถึงวันที่"
										     data-start_calendar="start_cheque_pass_date"
										     data-locale="th"
										     data-initialdate=""
										/>
									</div>
								</div>
								<div className="column field">
									<div className="field">
										<label>สถานะ</label>
										<select name="status"
										        className="ui dropdown fluid"
										        data-form2_setup="">
											<option value="">ทั้งหมด</option>
											<option value="wait_approve">เช็ครอตรวจสอบ</option>
											<option value="pass">เช็คผ่าน</option>
											<option value="not_pass">เช็คไม่ผ่าน</option>
											<option value="return">เช็คคืน</option>
											<option value="void">ยกเลิก</option>
										</select>
									</div>
								</div>
								<div className="column field">
									<div className="field">
										<label>ประเภท</label>
										<select name="method"
										        className="ui dropdown fluid"
										        data-form2_setup="">
											<option value="all">ทั้งหมด</option>
											<option value="deposit_in,pay_in,refund_in">เช็ครับ</option>
											<option value="deposit_out,pay_out,refund_out">เช็คจ่าย</option>
										</select>
									</div>
								</div>
								<div className="column field">
									<div className="field">
										<label>ผู้เปลี่ยนสถานะ</label>
										<input type="text" name="status_updated_user_id"/>
									</div>
								</div>
								<div className="column fluid right floated">
									<label style={{opacity: 0}}>อื่นๆ</label>
									<div className="flex row wrap right floated end-xs">
										<div style={{marginRight: '0.7rem'}}>
											<div className="ui labeled icon top right pointing dropdown button basic">
												<i className="download icon"/>
												<span className="text">ดาวโหลดรายงาน</span>
												<div className="menu">
													<div className="item" data-value="excel">Excel</div>
												</div>
											</div>
										</div>
										<button className="ui icon button green"
										        type="submit">
											<i className="search icon"/> ค้นหา
										</button>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>

				<div className="flex row wrap padded">
					<div className="col-xs-16 padded">
						<div className="ui basic table can click Table_root td-top-xs" style={{marginTop: 0}}>
							<div className="thead">
								<div className="tr">
									<div className="th span7">ข้อมูลเช็ค</div>
									<div className="th span7"/>
									<div className="th span2">สถานะ</div>
								</div>
							</div>
							<div className="tbody">
								{
									this.state.is_loading
										? <div className="tr">
											<div className="td center aligned" data-info="nodata">
												<div className="ui active centered inline small loader"/>
											</div>
										</div>
										: null
								}
								{
									this.state.payment_by_cheque.length === 0
									&& !this.state.is_loading
									&& (
										!window.Global.getAllQueryStrings().page
										|| window.Global.getAllQueryStrings().page === '1'
									)
										? <div className="tr">
											<div className="td span16" style={{textAlign: 'center'}}>ไม่พบข้อมูล</div>
										</div>
										: null
								}
								{
									!this.state.is_loading
									&& this.state.payment_by_cheque
									&& this.state.payment_by_cheque.length > 0 ?
										this.state.payment_by_cheque.map((payment_by_cheque, payment_by_cheque_index) => {
											let is_pay_in = Helper.isMethodMoneyIn(payment_by_cheque.method);
											return (
												<div className="tr" key={payment_by_cheque_index}>
													<div className="td span7">
														<ChequeInformation
															mode={payment_by_cheque.mode}
															payment_by_cheque={payment_by_cheque}
															setMode={(mode) => {
																this.setMode(mode, payment_by_cheque_index);
															}}
															is_pay_in={is_pay_in}
															onSuccess={(payment_by_cheque) => {
																let payment_by_cheques = [...this.state.payment_by_cheque];
																payment_by_cheques[payment_by_cheque_index] = payment_by_cheque;
																payment_by_cheques[payment_by_cheque_index].mode = 'view';
																this.setState({
																	payment_by_cheque: payment_by_cheques,
																})
															}}
														/>
													</div>
													<div className="td span7">
														<DrawTheMoney
															mode={payment_by_cheque.mode}
															payment_by_cheque={payment_by_cheque}
															setMode={(mode) => {
																this.setMode(mode, payment_by_cheque_index);
															}}
															is_pay_in={is_pay_in}
															onSuccess={(payment_by_cheque) => {
																let payment_by_cheques = [...this.state.payment_by_cheque];
																payment_by_cheques[payment_by_cheque_index] = payment_by_cheque;
																payment_by_cheques[payment_by_cheque_index].mode = 'view';
																this.setState({
																	payment_by_cheque: payment_by_cheques,
																})
															}}
														/>
													</div>
													<div className="td span2">
														<div
															dangerouslySetInnerHTML={{__html: payment_by_cheque.status_html}}/>
														{
															payment_by_cheque.status_updated_user ?
																<>
																	<div style={{marginTop: 5}}>
																		{payment_by_cheque.status_updated_user.name}
																	</div>
																	<div style={{marginTop: 5}}>
																		{window.Global.getDateThai(payment_by_cheque.status_updated_user.date_updated)}
																	</div>
																</>
																: null
														}
														{
															payment_by_cheque.status !== 'void'
															&& payment_by_cheque.mode === 'view' ?
																<div className="ui dropdown"
																     style={{marginTop: 5}}
																     ref={(ref) => {
																	     window.$(ref).dropdown({
																		     action: 'nothing'
																	     })
																     }}
																>
																	<div className="text">เปลี่ยนสถานะ</div>
																	<i className="dropdown icon"/>
																	<div className="menu">
																		{
																			payment_by_cheque.status !== 'pass' ?
																				<div className="item"
																				     onClick={() => {
																					     this.setMode('create', payment_by_cheque_index);
																				     }}
																				>
																					เช็คผ่าน
																				</div>
																				: null
																		}
																		{
																			payment_by_cheque.status !== 'not_pass' ?
																				<div className="item"
																				     onClick={() => {
																					     this.changeStatus(payment_by_cheque, 'not_pass', {
																						     onSuccess: (payment_by_cheque) => {
																							     this.setMode('view', payment_by_cheque_index, payment_by_cheque)
																						     }
																					     });
																				     }}
																				>
																					เช็คไม่ผ่าน
																				</div>
																				: null
																		}
																		{
																			payment_by_cheque.status !== 'return' ?
																				<div className="item"
																				     onClick={() => {
																					     this.changeStatus(payment_by_cheque, 'return', {
																						     onSuccess: (payment_by_cheque) => {
																							     this.setMode('view', payment_by_cheque_index, payment_by_cheque)
																						     }
																					     });
																				     }}
																				>
																					เช็คคืน
																				</div>
																				: null
																		}
																		{
																			payment_by_cheque.status !== 'wait_approve' ?
																				<div className="item"
																				     onClick={() => {
																					     this.changeStatus(payment_by_cheque, 'wait_approve', {
																						     onSuccess: (payment_by_cheque) => {
																							     this.setMode('view', payment_by_cheque_index, payment_by_cheque)
																						     }
																					     });
																				     }}
																				>
																					เช็ครอตรวจสอบ
																				</div>
																				: null
																		}
																	</div>
																</div>
																: null
														}

													</div>
												</div>
											)
										})
										: null
								}

							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}


	changeStatus(payment_by_cheque, status, options) {
		let _status = '';
		if (status === 'wait_approve') {
			_status = 'เช็ครอตรวจสอบ';
		}
		if (status === 'pass') {
			_status = 'เช็คผ่าน';
		}
		if (status === 'not_pass') {
			_status = 'เช็คไม่ผ่าน';
		}
		if (status === 'return') {
			_status = 'เช็คคืน';
		}

		window.Global.confirm({
			title: 'ยืนยันเเปลี่ยนสถานะเป็น "' + _status + '"',
			content: '<form class="ui form">\n\t<p>โปรดยืนยันการเปลี่ยนสถานะ</p>\n\t<div class="ui error message"></div>\n</form>',
			cancel_text: 'ไม่ดำเนินการ',
			approve_text: 'เปลี่ยนสถานะ',
			onShowToSetupForm: ($modal) => {
				$modal.find('form').form2('setup');
				$modal.find('form').form2('submit', {
					method: 'PUT',
					url: process.env.REACT_APP_DOMAIN + '/api/payment/payment_by_cheque/change_status',
					loadingButton: $modal.find('.button.approve'),
					beforeSent: (data) => {
						data.status = status;
						data.payment_by_cheque_id = payment_by_cheque.id;
						return data;
					},
					onSuccess: (response) => {
						$modal.modal('hide');
						window.Global.messageTop({
							type: 'positive',
							message: 'เปลี่ยนสถานะสำเร็จ'
						});
						options.onSuccess(response.payment_by_cheque)
					}
				});
			}
		});
	}
}

class ChequeInformation extends React.Component {
	returnView() {
		return (
			<>
				<div ref={(ref) => {
					window.GlobalFunc.setupInlineFileUpload(window.$(ref), {
						source: 'payment_by_cheque_file_upload',
						reference_id: this.props.payment_by_cheque.id,
						file_uploads: this.props.payment_by_cheque['payment_by_cheque_file_upload'],
						file_upload_types: [
							{
								name: 'ไฟล์เอกสารสำคัญ',
								type: 'important'
							}
						]
					});
				}}
				>
					<div className="ui form message green">
						<div className="flex row wrap padded two column computer">
							<div className="field column">
								<label style={{color: label_color}}>อ้างอิงถึง</label>
								<div>
									<a className={"link"}
									   href={process.env.REACT_APP_DOMAIN + this.props.payment_by_cheque.payment.url}>{this.props.payment_by_cheque.payment.title + ' ' + this.props.payment_by_cheque.payment.desc}</a>
								</div>
							</div>
							<div className="field column">
								<label style={{color: label_color}}>มูลค่าเช็ค</label>
								<div style={!this.props.payment_by_cheque.price
									? {color: empty_color} : {color: '#000'}
								}>
									{'฿' + this.props.payment_by_cheque.price.format(2) || "-"}
								</div>
							</div>
							<div className="field column">
								<label style={{color: label_color}}>วันที่รับ/จ่ายเช็ค</label>
								<div style={!this.props.payment_by_cheque.paid_on
									? {color: empty_color} : {color: '#000'}
								}>
									{
										this.props.payment_by_cheque.paid_on ?
											window.Global.getDateThai(this.props.payment_by_cheque.paid_on, {is_show_time: false})
											: "-"
									}
								</div>
							</div>
							<div className="field column">
								<label style={{color: label_color}}>วันที่เช็ค</label>
								<div style={!this.props.payment_by_cheque.cheque_doc_date
									? {color: empty_color} : {color: '#000'}
								}>
									{
										this.props.payment_by_cheque.cheque_doc_date ?
											window.Global.getDateThai(this.props.payment_by_cheque.cheque_doc_date)
											: "-"
									}
								</div>
							</div>

							<div className="field column">
								<label style={{color: label_color}}>เช็คเลขที่</label>
								<div style={!this.props.payment_by_cheque.cheque_no
									? {color: empty_color}
									: {color: '#000'}
								}>
									{this.props.payment_by_cheque.cheque_no || "-"}
								</div>
							</div>
							<div className="field column">
								<label style={{color: label_color}}>สาขาเลขที่</label>
								<div
									style={!this.props.payment_by_cheque.cheque_branch
										? {color: empty_color}
										: {color: '#000'}
									}>
									{this.props.payment_by_cheque.cheque_branch || "-"}
								</div>
							</div>
							{
								this.props.is_pay_in
									?
									<div
										className="column flex wrap"
										style={{marginBottom: 5}}>
										<label style={{color: label_color}}>ธนาคารที่ระบุบนเช็ค</label>
										<div
											style={!this.props.payment_by_cheque.cheque_bank_code_name
												? {color: empty_color}
												: {color: '#000'}
											}>
											{
												this.props.payment_by_cheque.cheque_bank_code_name ?
													this.props.payment_by_cheque.cheque_bank_code_name
													: "-"
											}
										</div>
									</div>
									: null
							}
							<div className="field column">
								<label style={{color: label_color}}>วันครบกำหนดเช็ค</label>
								<div style={!this.props.payment_by_cheque.cheque_due_date
									? {color: empty_color}
									: {color: '#000'}
								}>
									{
										this.props.payment_by_cheque.cheque_due_date ?
											window.Global.getDateThai(this.props.payment_by_cheque.cheque_due_date)
											: "-"
									}
								</div>
							</div>
							<div className="field column">
								<label style={{color: label_color}}>จ่าย</label>
								<div style={!this.props.payment_by_cheque.cheque_pay
									? {color: empty_color}
									: {color: '#000'}
								}>
									{this.props.payment_by_cheque.cheque_pay || "-"}
								</div>
							</div>
							<div className="field column">
								<label style={{color: label_color}}>บัญชีที่</label>
								<div
									style={!this.props.payment_by_cheque.cheque_account_no
										? {color: empty_color}
										: {color: '#000'}
									}>
									{this.props.payment_by_cheque.cheque_account_no || "-"}
								</div>
							</div>
							{
								!this.props.is_pay_in
								&& this.props.payment_by_cheque.cheque_remind_deposit_before_date ?
									<div className="column flex wrap"
									     style={{marginBottom: 5}}>
										<label style={{color: label_color}}>บันทึกช่วยเตือนฝากเงินก่อนวันที่</label>
										<div style={!this.props.payment_by_cheque.cheque_remind_deposit_before_date
											? {color: empty_color}
											: {color: '#000'}
										}>{
											window.Global.getDateThai(this.props.payment_by_cheque.cheque_remind_deposit_before_date)
											|| "-"
										}</div>
									</div>
									: null
							}
						</div>
						<div>
							{
								this.props.payment_by_cheque.mode === 'view'
									?
									<button className={"ui button mini"}
									        onClick={() => {
										        this.props.setMode('edit')
									        }}>
										แก้ไขข้อมูลเช็ค
									</button>
									: null
							}
						</div>
					</div>
					<div className="flex row wrap padded two column computer">
						<div className="column flex row wrap" style={{marginBottom: 5}}>
							<div id="file-upload"/>
						</div>
						<div className="column flex row wrap" style={{marginBottom: 5}}>
							{
								this.props.payment_by_cheque.payment_by_cheque_purchase_order
								&& this.props.payment_by_cheque.payment_by_cheque_purchase_order.map((payment_by_cheque_purchase_order, payment_by_cheque_purchase_order_i) => {
									return (
										<a className={"link"} style={{display: 'block'}}
										   key={payment_by_cheque_purchase_order_i}
										   href={process.env.REACT_APP_DOMAIN + payment_by_cheque_purchase_order.payment.url}>
											{payment_by_cheque_purchase_order.payment.title} {payment_by_cheque_purchase_order.payment.desc}
										</a>
									);
								})
							}
							<a className={"link"} style={{display: 'block'}}
							   href={process.env.REACT_APP_DOMAIN + '/payments/new?method=pay_out&is_express=1&payment_by_cheque_id=' + this.props.payment_by_cheque.id}>
								บันทึกใบกำกับภาษี
							</a>
						</div>
					</div>
				</div>

			</>
		);
	}

	returnEditForm() {
		return (
			<form className={"ui form"}
			      ref={(ref) => {
				      window.$(ref).form2('setup');
				      window.$(ref).form2('init', {
					      data: this.props.payment_by_cheque
				      });
				      window.$(ref).form2('submit', {
					      method: 'PUT',
					      url: process.env.REACT_APP_DOMAIN + '/api/payment/payment_by_cheque',
					      loadingButton: window.$(ref).find('.button.approve'),
					      beforeSent: (data) => {
						      return data;
					      },
					      onSuccess: (response) => {
						      console.log(response);
						      window.Global.messageTop({
							      type: 'positive',
							      message: 'แก้ไขข้อมูลสำเร็จ'
						      });
						      this.props.onSuccess(response.payment_by_cheque)
					      }
				      });
			      }}
			>
				<div className={"flex row wrap padded two column computer"}>
					<div className={"column field required"}>
						<label htmlFor="paid_on">วันที่รับ/จ่ายเช็ค</label>
						<div data-form_calendar="date"
						     data-input_name="paid_on"
						     data-placeholder="ไม่ระบุ"
						     data-initialdate={this.props.payment_by_cheque.paid_on}
						     data-locale="th"/>
					</div>
					<div className={"column field required"}>
						<label htmlFor="cheque_doc_date">วันที่เช็ค</label>
						<div data-form_calendar="date"
						     data-input_name="cheque_doc_date"
						     data-placeholder="ไม่ระบุ"
						     data-initialdate={this.props.payment_by_cheque.cheque_doc_date}
						     data-locale="th"/>
					</div>
					<div className={"column field"}>
						<label htmlFor="cheque_no">เช็คเลขที่</label>
						<input type={"text"} name={'cheque_no'} defaultValue={this.props.payment_by_cheque.cheque_no}
						       placeholder={"เช็คเลขที่"}/>
					</div>
					<div className={"column field"}>
						<label htmlFor="cheque_branch">สาขาเลขที่</label>
						<input type={"text"} name={'cheque_branch'}
						       defaultValue={this.props.payment_by_cheque.cheque_branch} placeholder={"สาขาเลขที่"}/>
					</div>
					{
						this.props.is_pay_in ?
							<div className={"column field"}>
								<label htmlFor="cheque_branch">ธนาคารที่ระบุบนเช็ค</label>
								<select name="cheque_bank_code"
								        data-form2_setup="done"
								        ref={(ref) => {
									        window.$(ref).dropdown();
								        }}
								        defaultValue={this.props.payment_by_cheque.cheque_bank_code}
								>
									<option value=" ">ไม่ระบุ</option>
									<option value="002">ธนาคารกรุงเทพ</option>
									<option value="025">ธนาคารกรุงศรีอยุธยา</option>
									<option value="004">ธนาคารกสิกรไทย</option>
									<option value="069">ธนาคารเกียรตินาคิน</option>
									<option value="022">ธนาคารซีไอเอ็มบีไทย</option>
									<option value="011">ธนาคารทหารไทย</option>
									<option value="067">ธนาคารทิสโก้</option>
									<option value="014">ธนาคารไทยพาณิชย์</option>
									<option value="071">ธนาคารไทยเครดิตเพื่อรายย่อย</option>
									<option value="065">ธนาคารธนชาต</option>
									<option value="024">ธนาคารยูโอบี</option>
									<option value="073">ธนาคารแลนด์ แอนด์ เฮาส์</option>
									<option value="020">ธนาคารสแตนดาร์ดชาร์เตอร์ด (ไทย)</option>
									<option value="006">ธนาคารกรุงไทย</option>
									<option value="098">ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย</option>
									<option value="034">ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร</option>
									<option value="035">ธนาคารเพื่อการส่งออกและนำเข้าแห่งประเทศไทย</option>
									<option value="030">ธนาคารออมสิน</option>
									<option value="033">ธนาคารอาคารสงเคราะห์</option>
									<option value="066">ธนาคารอิสลามแห่งประเทศไทย</option>
									<option value="070">ธนาคารไอซีบีซี (ไทย)</option>
								</select>
							</div>
							: null
					}
					<div className={"column field"}>
						<label htmlFor="cheque_due_date">วันที่ครบกำหนดเช็ค</label>
						<div data-form_calendar="date"
						     data-input_name="cheque_due_date"
						     data-placeholder="ไม่ระบุ"
						     data-initialdate={this.props.payment_by_cheque.cheque_due_date}
						     data-locale="th"/>
					</div>
					<div className={"column field"}>
						<label htmlFor="cheque_pay">จ่าย</label>
						<input type={"text"} name={'cheque_pay'}
						       defaultValue={this.props.payment_by_cheque.cheque_pay}/>
					</div>
					<div className={"column field"}>
						<label htmlFor="cheque_account_no">บัญชีที่</label>
						<input type={"text"} name={'cheque_account_no'}
						       defaultValue={this.props.payment_by_cheque.cheque_account_no}/>
					</div>
					{
						!this.props.is_pay_in ?
							<div className={"column field"}>
								<label
									htmlFor="cheque_remind_deposit_before_date">บันทึกช่วยเตือนฝากเงินก่อนวันที่</label>
								<div data-form_calendar="date"
								     data-input_name="cheque_remind_deposit_before_date"
								     data-placeholder="ไม่ระบุ"
								     data-initialdate={this.props.payment_by_cheque.cheque_remind_deposit_before_date}
								     data-locale="th"/>
							</div>
							: null
					}
				</div>
				<div className="ui error message"/>
				<div className={"flex row"}>
					<div className="right floated">
						<input type={"hidden"} name={"payment_by_cheque_id"} value={this.props.payment_by_cheque.id}/>
						<button type={"button"}
						        className={"ui button"}
						        ref={(ref) => {
							        this.cancle_btn = window.$(ref)
						        }}
						        onClick={() => {
							        this.cancle_btn.addClass('loading');
							        this.cancle_btn.attr('disabled', true);
							        this.props.setMode('view');
						        }}
						>
							ยกเลิก
						</button>
						<button type={"submit"} className={"ui button blue approve"}>บันทึกข้อมูล</button>
					</div>
				</div>
			</form>
		);
	}

	render() {
		if (this.props.mode === 'edit') {
			return this.returnEditForm();
		}
		return this.returnView();
	}
}

class DrawTheMoney extends React.Component {


	renderView() {
		return (
			<div className="flex row" style={{position: 'relative'}}>
				<div className="col-xs-6" style={{textAlign: 'center'}}>
					<i className={'icon check'}
					   style={{fontSize: 80, opacity: 0.2, lineHeight: 1, color: 'green'}}/>
				</div>
				<div className="col-xs-10">
					<div style={{marginBottom: 5}}>
									<span
										style={{color: label_color}}>{!this.props.is_pay_in ? "ธนาคารที่หักเงินจ่ายเช็ค" : "ธนาคารที่ขึ้นเงิน"}&nbsp;&nbsp;</span>
						<span style={{color: '#000'}}>
											{
												this.props.payment_by_cheque
												&& !this.props.is_pay_in
												&& this.props.payment_by_cheque.pass_payment_by_bank_transfer
												&& this.props.payment_by_cheque.pass_payment_by_bank_transfer.bank_from ?
													<>
														{this.props.payment_by_cheque.pass_payment_by_bank_transfer.bank_from.name + " (" + this.props.payment_by_cheque.pass_payment_by_bank_transfer.bank_from.branch_name + ")"}
														<br/>
														{this.props.payment_by_cheque.pass_payment_by_bank_transfer.bank_from.code_name}
													</>
													: !this.props.is_pay_in ?
													"-"
													: null
											}
							{
								this.props.payment_by_cheque
								&& this.props.is_pay_in
								&& this.props.payment_by_cheque.pass_payment_by_bank_transfer
								&& this.props.payment_by_cheque.pass_payment_by_bank_transfer.bank_to ?
									<>
										{this.props.payment_by_cheque.pass_payment_by_bank_transfer.bank_to.name + " (" + this.props.payment_by_cheque.pass_payment_by_bank_transfer.bank_to.branch_name + ")"}
										<br/>
										{this.props.payment_by_cheque.pass_payment_by_bank_transfer.bank_to.code_name}
									</>
									: this.props.is_pay_in ?
									"-"
									: null

							}
										</span>
					</div>
					<div style={{marginBottom: 5}}>
						<span style={{color: label_color}}>จำนวนเงิน&nbsp;&nbsp;</span>
						<span
							style={
								this.props.payment_by_cheque.pass_payment_by_bank_transfer
								&& parseFloat(this.props.payment_by_cheque.pass_payment_by_bank_transfer.amount) < 0
									? {color: 'red'}
									: {color: 'green'}
							}
						>
										{
											this.props.payment_by_cheque
											&& this.props.payment_by_cheque.pass_payment_by_bank_transfer
											&& this.props.payment_by_cheque.pass_payment_by_bank_transfer.amount ?
												'฿' + this.props.payment_by_cheque.pass_payment_by_bank_transfer.amount.format(2)
												: "฿0"
										}
									</span>
					</div>
					<div style={{marginBottom: 5}}>
									<span
										style={{color: label_color}}>วันที่{!this.props.is_pay_in ? "จ่ายเงิน" : "ได้รับเงิน"}&nbsp;&nbsp;</span>
						<span
							style={!this.props.payment_by_cheque.pass_payment_by_bank_transfer || !this.props.payment_by_cheque.pass_payment_by_bank_transfer.paid_on ? {color: empty_color} : {color: '#000'}}>
										{
											this.props.payment_by_cheque
											&& this.props.payment_by_cheque.pass_payment_by_bank_transfer
											&& this.props.payment_by_cheque.pass_payment_by_bank_transfer.paid_on ?
												window.Global.getDateThai(this.props.payment_by_cheque.pass_payment_by_bank_transfer.paid_on)
												: "-"
										}
									</span>
					</div>
					{
						this.props.payment_by_cheque
						&& this.props.payment_by_cheque.pass_payment_by_bank_transfer ?
							<div style={{marginBottom: 5}}>
								<span style={{color: label_color}}>หมายเลขอ้างอิง&nbsp;&nbsp;</span>
								<span
									style={!this.props.payment_by_cheque.pass_payment_by_bank_transfer || !this.props.payment_by_cheque.pass_payment_by_bank_transfer.bank_reference_code ? {color: empty_color} : {color: '#000'}}>
												{this.props.payment_by_cheque.pass_payment_by_bank_transfer.bank_reference_code || '-'}
											</span>
							</div>
							: null
					}
					{
						this.props.payment_by_cheque
						&& this.props.payment_by_cheque.pass_payment_by_bank_transfer ?
							<div style={{marginBottom: 5}}>
								<span style={{color: label_color}}>หมายเหตุ&nbsp;&nbsp;</span>
								<span
									style={!this.props.payment_by_cheque.pass_payment_by_bank_transfer || !this.props.payment_by_cheque.pass_payment_by_bank_transfer.remark ? {color: empty_color} : {color: '#000'}}>
												{this.props.payment_by_cheque.pass_payment_by_bank_transfer.remark || '-'}
											</span>
							</div>
							: null
					}
				</div>


			</div>
		);
	}

	renderForm() {
		let _date = new Date();
		return (
			<form className={"ui form message green"}
			      ref={(ref) => {
				      this.$parent = ref;
				      window.$(ref).form2('setup');
				      window.$(ref).form2('submit', {
					      method: 'PUT',
					      url: process.env.REACT_APP_DOMAIN + '/api/payment/payment_by_cheque/pass',
					      loadingButton: window.$(ref).find('.button.approve'),
					      beforeSent: (data) => {
						      data.paid_on = data.paid_on + ' ' + data.hour + ':' + data.minute + ':00';
						      delete data.hour;
						      delete data.minute;
						      return data;
					      },
					      onSuccess: (response) => {
						      window.Global.messageTop({
							      type: 'positive',
							      message: 'ขึ้นเงินสำเร็จ'
						      });
						      this.props.onSuccess(response.payment_by_cheque)
					      }
				      });
				      window.$(ref).find('input[name="cheque_bank_id"]').explorer({
					      url: process.env.REACT_APP_DOMAIN + '/api/bank',
					      additionalData: {
						      limit: 10,
						      page: 1
					      },
					      key: 'bank',
					      template: {
						      list: '<a class="item flex row">{{name}}</a>',
						      selected: {
							      text: 'name',
							      value: 'id',
							      placeholder: 'เลือกธนาคาร'
						      }
					      }
				      });
				      if (this.props.payment_by_cheque.cheque_bank) {
					      window.$(ref).find('input[name="cheque_bank_id"]').explorer('set value', this.props.payment_by_cheque.cheque_bank);
				      }

			      }}
			>
				<h3 className={"ui header dividing"}
				    style={{marginTop: 0, marginBottom: '1rem', color: '#000'}}>เช็คผ่าน</h3>
				<div className="flex row wrap padded two column computer">
					<div className="column field required">
						<label>ธนาคารที่{this.props.is_pay_in ? "ขึ้นเงิน" : "หักเงิน"}</label>
						<input name={"cheque_bank_id"}/>
					</div>
					<div className="column field required"><label>จำนวนเงิน</label>
						<div className="ui right labeled input">
							<input type="text" name="price"
							       defaultValue={parseFloat(this.props.payment_by_cheque.price) > 0 ? parseFloat(this.props.payment_by_cheque.price) : 0}
							       style={{flexShrink: 1, width: '100%'}}/>
							<div className="ui basic label">บาท</div>
						</div>
					</div>
					<div className="column field required">
						<label>{this.props.is_pay_in ? "วันที่ได้รับเงิน" : "วันที่หักเงิน"}</label>
						<div data-form_calendar="date"
						     data-input_name="paid_on"
						     data-placeholder={this.props.is_pay_in ? "วันที่ได้รับเงิน" : "วันที่หักเงิน"}
						     data-locale="th"
						     data-initialdate="now"
						/>
					</div>
					<div className={"column field"}>
						<div className="flex row wrap two column computer padded">
							<div className="column field" style={{marginBottom: 0}}>
								<label>ชั่วโมง</label>
								<select className="ui dropdown fluid"
								        name="hour"
								        ref={(ref) => {
									        window.$(ref).dropdown();
								        }}
								        defaultValue={_date.getHours()}
								>
									<option value="00">00</option>
									<option value="01">01</option>
									<option value="02">02</option>
									<option value="03">03</option>
									<option value="04">04</option>
									<option value="05">05</option>
									<option value="06">06</option>
									<option value="07">07</option>
									<option value="08">08</option>
									<option value="09">09</option>
									<option value="10">10</option>
									<option value="11">11</option>
									<option value="12">12</option>
									<option value="13">13</option>
									<option value="14">14</option>
									<option value="15">15</option>
									<option value="16">16</option>
									<option value="17">17</option>
									<option value="18">18</option>
									<option value="19">19</option>
									<option value="20">20</option>
									<option value="21">21</option>
									<option value="22">22</option>
									<option value="23">23</option>
								</select>
							</div>
							<div className="column field" style={{marginBottom: 0}}>
								<label>นาที</label>
								<select className="ui dropdown fluid"
								        name="minute"
								        ref={(ref) => {
									        window.$(ref).dropdown();
								        }}
								        defaultValue={_date.getMinutes()}
								>
									<option value="00">00</option>
									<option value="01">01</option>
									<option value="02">02</option>
									<option value="03">03</option>
									<option value="04">04</option>
									<option value="05">05</option>
									<option value="06">06</option>
									<option value="07">07</option>
									<option value="08">08</option>
									<option value="09">09</option>
									<option value="10">10</option>
									<option value="11">11</option>
									<option value="12">12</option>
									<option value="13">13</option>
									<option value="14">14</option>
									<option value="15">15</option>
									<option value="16">16</option>
									<option value="17">17</option>
									<option value="18">18</option>
									<option value="19">19</option>
									<option value="20">20</option>
									<option value="21">21</option>
									<option value="22">22</option>
									<option value="23">23</option>
									<option value="24">24</option>
									<option value="25">25</option>
									<option value="26">26</option>
									<option value="27">27</option>
									<option value="28">28</option>
									<option value="29">29</option>
									<option value="30">30</option>
									<option value="31">31</option>
									<option value="32">32</option>
									<option value="33">33</option>
									<option value="34">34</option>
									<option value="35">35</option>
									<option value="36">36</option>
									<option value="37">37</option>
									<option value="38">38</option>
									<option value="39">39</option>
									<option value="40">40</option>
									<option value="41">41</option>
									<option value="42">42</option>
									<option value="43">43</option>
									<option value="44">44</option>
									<option value="45">45</option>
									<option value="46">46</option>
									<option value="47">47</option>
									<option value="48">48</option>
									<option value="49">49</option>
									<option value="50">50</option>
									<option value="51">51</option>
									<option value="52">52</option>
									<option value="53">53</option>
									<option value="54">54</option>
									<option value="55">55</option>
									<option value="56">56</option>
									<option value="57">57</option>
									<option value="58">58</option>
									<option value="59">59</option>
								</select>
							</div>
						</div>
					</div>
					<div className="column field">
						<label>หมายเลขอ้างอิง (Ref)</label>
						<input type="text" name="bank_reference_code"/>
					</div>
					<div className="column field">
						<label>หมายเหตุ</label>
						<textarea name={"remark"} rows={1}/>
					</div>
				</div>
				<div className="ui error message"/>
				<div className={"flex row"}>
					<div className="right floated">
						<input type={"hidden"} name={"payment_by_cheque_id"} value={this.props.payment_by_cheque.id}/>
						<button type={"button"}
						        className={"ui button"}
						        ref={(ref) => {
							        this.cancle_btn = window.$(ref)
						        }}
						        onClick={() => {
							        this.cancle_btn.addClass('loading');
							        this.cancle_btn.attr('disabled', true);
							        this.props.setMode('view');
						        }}
						>
							ยกเลิก
						</button>
						<button type={"submit"} className={"ui button blue approve"}>ยืนยันเช็คผ่าน</button>
					</div>
				</div>
			</form>
		);
	}

	render() {
		if (this.props.mode === 'create') {
			return this.renderForm();
		}
		if (this.props.mode !== 'create') {
			if (this.props.payment_by_cheque.status !== 'pass') {
				return (
					<div style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: '100%'
					}}>
						<div style={{textAlign: 'center'}}>
							<h3 className={"ui header"}
							    style={{marginTop: 0}}>ไม่พบข้อมูล{this.props.is_pay_in ? "ขึ้นเงิน" : "หักเงิน"}</h3>
							{
								!this.props.payment_by_cheque.is_void
								&& this.props.payment_by_cheque.mode === 'view'
									?
									<button type={"button"}
									        className={"ui button green"}
									        onClick={() => {
										        this.props.setMode('create')
									        }}>บันทึกเช็คผ่าน</button>
									: null
							}
						</div>
					</div>
				);
			}
			return this.renderView();
		}
	}
}
